import { IconArrowDown, IconArrowUp } from '@/components/Icons';

/** Quantas posições o membro subiu ou caiu em relação ao período anterior. */
export function PositionDelta({ change }: { change: number | null }) {
  if (change === null || change === 0) return null;
  const up = change > 0;
  return (
    <span
      className={up ? 'positive' : 'negative'}
      style={{ fontSize: 10.5, display: 'inline-flex', alignItems: 'center' }}
      title={`${up ? 'Subiu' : 'Caiu'} ${Math.abs(change)} posição(ões) vs. período anterior`}
    >
      {up ? <IconArrowUp /> : <IconArrowDown />}
      {Math.abs(change)}
    </span>
  );
}
